module.exports = "<div class=\"header\">\n  <img src=\"assets/images/logo.svg\" class=\"img-logo\" alt=\"\">\n</div>\n"